import { FC, useState } from "react"
import { Dialog } from "@headlessui/react"

interface Props {
  isOpen: boolean
  connectorName: string
  onConfirm: () => void
  onCancel: () => void
  isDeleting: boolean
}

const DeleteConfirmationModal: FC<Props> = ({
  isOpen,
  connectorName,
  onConfirm,
  onCancel,
  isDeleting
}) => {
  const [confirmText, setConfirmText] = useState("")

  const handleClose = () => {
    setConfirmText("")
    onCancel()
  }

  const handleConfirm = () => {
    if (confirmText === "DELETE") {
      onConfirm()
      setConfirmText("")
    }
  }

  const isConfirmValid = confirmText === "DELETE"

  return (
    <Dialog open={isOpen} onClose={handleClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-lg rounded-lg bg-white p-6 shadow-xl">
          <Dialog.Title className="text-lg font-bold text-gray-900 mb-2">
            Delete Connector
          </Dialog.Title>

          <div className="space-y-4">
            <p className="text-sm text-gray-600">
              Are you sure you want to delete the connector{" "}
              <strong className="text-gray-900">{connectorName}</strong>?
            </p>

            <div className="bg-red-50 border border-red-200 rounded-md p-3">
              <p className="text-sm text-red-800">
                <strong>Warning:</strong> This action cannot be undone. All
                connector logs will also be deleted.
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Type{" "}
                <code className="bg-gray-100 px-1 py-0.5 rounded">DELETE</code>{" "}
                to confirm:
              </label>
              <input
                type="text"
                value={confirmText}
                onChange={e => setConfirmText(e.target.value)}
                placeholder="Type DELETE"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                autoFocus
              />
            </div>

            <div className="flex justify-end space-x-3 pt-4">
              <button
                type="button"
                onClick={handleClose}
                disabled={isDeleting}
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 disabled:opacity-50"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleConfirm}
                disabled={!isConfirmValid || isDeleting}
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                {isDeleting ? "Deleting..." : "Delete Connector"}
              </button>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  )
}

export default DeleteConfirmationModal
